(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cro-countdown"] && !Shopify.designMode) return;
  try {
    class CountdownBar extends HTMLElement {
    connectedCallback() {
      this.endsAt = Number(this.dataset.endsAt) * 1000;
      if (!this.endsAt) return;

      this.nums = {};
      this.querySelectorAll('[data-unit]').forEach((el) => {
        this.nums[el.dataset.unit] = el;
      });

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      let left = Math.floor((this.endsAt - Date.now()) / 1000);

      if (left <= 0) {
        clearInterval(this.timer);
        // La oferta ha terminado: se retira en vez de quedarse a cero mintiendo.
        this.hidden = true;
        return;
      }

      const days = Math.floor(left / 86400);
      left -= days * 86400;
      const hours = Math.floor(left / 3600);
      left -= hours * 3600;
      const minutes = Math.floor(left / 60);
      const seconds = left - minutes * 60;

      this.set('days', days);
      this.set('hours', hours);
      this.set('minutes', minutes);
      this.set('seconds', seconds);
    }

    set(unit, value) {
      const el = this.nums[unit];
      if (!el) return;
      const text = String(value).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }
  }

  if (!customElements.get('countdown-bar')) {
    customElements.define('countdown-bar', CountdownBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cro-review-strip"] && !Shopify.designMode) return;
  try {
    class ReviewStrip extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cro-rstrip__track');
      this.arrows = Array.from(this.querySelectorAll('.cro-rstrip__arrow'));
      if (!this.track) return;

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          const card = this.track.querySelector('.cro-rstrip__card');
          if (!card) return;
          const step = card.getBoundingClientRect().width;
          this.track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
        });
      });

      // El scroll manda: el estado de las flechas se lee de dónde está el
      // carrusel, no de un contador aparte que se desincroniza al arrastrar.
      this.sync = this.sync.bind(this);
      this.track.addEventListener('scroll', this.sync, { passive: true });
      this.sync();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.sync);
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.arrows.forEach((arrow) => {
        // Un par de píxeles de margen: el scroll suave rara vez cae clavado.
        const atEnd = Number(arrow.dataset.dir) > 0 ? x >= max - 2 : x <= 2;
        arrow.setAttribute('aria-disabled', String(atEnd));
      });
    }
  }

  if (!customElements.get('review-strip')) {
    customElements.define('review-strip', ReviewStrip);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cro-video-wall"] && !Shopify.designMode) return;
  try {
    class VwallCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cro-vwall__track');
      this.dots = Array.from(this.querySelectorAll('.cro-vwall__dot'));
      if (!this.track || !this.dots.length) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const page = Number(dot.dataset.page);
          this.track.scrollTo({
            left: page * this.track.clientWidth,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
      });

      // rAF: el evento scroll dispara muchas veces por gesto y no hace falta
      // recalcular en todas.
      let pending = false;
      this.track.addEventListener(
        'scroll',
        () => {
          if (pending) return;
          pending = true;
          requestAnimationFrame(() => {
            this.sync();
            pending = false;
          });
        },
        { passive: true }
      );

      this.sync();
    }

    sync() {
      const width = this.track.clientWidth;
      if (!width) return;
      const current = Math.round(this.track.scrollLeft / width);
      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('vwall-carousel')) {
    customElements.define('vwall-carousel', VwallCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
